/* ============================================================
   EI — L'ÉTAL (proposition avant paiement)
   ex-"Smart Threshold V1" — évolution 2026-08-04
   ============================================================
   Nom de fichier conservé (theme.liquid, CSS ei-st-*) pour ne rien casser.

   Principe : au clic "Commander", un CALQUE (jamais une page) propose
   jusqu'à 6 petits formats. Le bouton Commander reste le roi et son
   montant s'anime à chaque ajout.

   Deux modes choisis automatiquement :
     - "seuil"   : panier dans la fenêtre presque-seuil
                   (44-49 €, 80-90 €, ou campagne) → cadrage GAIN + jauge.
     - "plaisir" : tous les autres paniers → cadrage PLAISIR, produits ≤ prix max.

   Garde-fous anti-friction :
     - 1 seule fois par session (sessionStorage ei_etal_seen), quelle que soit la sortie
     - priorité au rappel "petit mot" Mamma (si lui a déjà preventDefault, on s'efface)
     - aucun fetch au clic : le pool produits est rendu server-side en JSON
     - groupe témoin (holdout) réglable pour pouvoir MESURER l'impact réel
     - interrupteur ON/OFF côté Customizer (si OFF, le snippet n'est pas rendu du tout)

   Mesure : événements GA4 ei_etal_* + attribut de commande `_ei_etal`
   (bucket + mode) lisible dans les commandes Shopify.
   ============================================================ */

(function () {
  'use strict';

  const CONFIG = {
    SEUIL_RELAIS: 4900,
    SEUIL_DOMICILE: 9000,
    /* 2026-09-17 — Repli SEULEMENT. La vraie largeur vient du réglage Customizer
       « Fenêtre du coup de pouce », lue sur data-ei-smart-fenetre via
       interceptWindowCents(). Doit rester alignée sur le défaut du schéma de
       sections/ei-cart-popover.liquid (19 €).
       ⚠️ AVANT CE JOUR cette règle était écrite en dur à TROIS endroits :
       le Liquid du tiroir, ei-cart-popover.js, et ici. Le 12-09 seuls les deux
       premiers ont été corrigés — l'Étal a continué de ne s'ouvrir qu'entre
       44 et 49 €, donc les produits 10-20 € de la collection ne sortaient jamais.
       Il n'y a DÉSORMAIS QU'UNE SEULE SOURCE : le réglage Customizer. */
    INTERCEPT_WINDOW_CENTS: 1900,
    SUGGEST_DELTA_BUFFER_CENTS: 200,  /* en mode seuil : delta + 2 € max */
    SEEN_KEY: 'ei_etal_seen',
    BUCKET_KEY: 'ei_etal_bucket',
    MIN_ITEMS: 2                      /* sous 2 produits affichables, on n'ouvre pas */
  };

  let state = {
    mode: null,
    activeSeuil: null,
    deltaCents: 0,
    items: [],
    pool: null,
    settings: null,
    cartRef: null,
    isOpen: false,
    pendingCheckoutHref: '/checkout',
    totalCents: 0,
    seuilBaseCents: 0,
    addsCount: 0,
    addsValueCents: 0
  };

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const modalRoot = () => $('[data-ei-smart-threshold]');

  function moneyFormat(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function getCart() {
    return (window.eiCartPopover && window.eiCartPopover.getCart()) || null;
  }

  function pushGA4(eventName, extra) {
    const cart = getCart();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: eventName,
      ei_version: 'v2',
      ei_source: 'cart',
      ei_action: 'etal',
      ei_etal_mode: state.mode || '',
      ei_etal_bucket: state.bucket || '',
      cart_total: cart ? cart.total_price / 100 : 0,
      cart_items_count: cart ? cart.item_count : 0
    }, extra || {}));
  }

  /* ===== Réglages lus depuis le snippet Liquid ===== */
  function readSettings() {
    const el = modalRoot();
    if (!el) return null;
    const d = el.dataset;
    return {
      prixMaxCents: parseInt(d.eiEtalPrixMax || '1000', 10),
      panierMinCents: parseInt(d.eiEtalPanierMin || '0', 10),
      nbMobile: parseInt(d.eiEtalNbMobile || '4', 10),
      nbDesktop: parseInt(d.eiEtalNbDesktop || '6', 10),
      holdout: parseInt(d.eiEtalHoldout || '0', 10),
      marquer: d.eiEtalMarquer === 'true'
    };
  }

  /* ===== Pool de produits (rendu server-side, parsé une seule fois) ===== */
  function readPool() {
    if (state.pool) return state.pool;
    const el = $('[data-ei-etal-pool]');
    if (!el) return (state.pool = []);
    try {
      const parsed = JSON.parse(el.textContent || '[]');
      state.pool = Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      console.warn('[ei-etal] pool illisible', err);
      state.pool = [];
    }
    return state.pool;
  }

  /* ===== Groupe témoin ===== */
  function getBucket(holdoutPct) {
    if (!holdoutPct || holdoutPct <= 0) return 'A';
    try {
      let b = localStorage.getItem(CONFIG.BUCKET_KEY);
      if (b !== 'A' && b !== 'B') {
        b = (Math.random() * 100 < holdoutPct) ? 'B' : 'A';
        localStorage.setItem(CONFIG.BUCKET_KEY, b);
      }
      return b;
    } catch (e) {
      return 'A';
    }
  }

  /* Marque la commande pour pouvoir comparer exposés / témoins côté Shopify.
     Attribut préfixé "_" : invisible côté client, lisible via l'API commandes. */
  function markOrder(tag) {
    if (!state.settings || !state.settings.marquer) return;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes: { '_ei_etal': tag } })
      }).catch(function () {});
    } catch (e) {}
  }

  /* Le compte des ajouts ne vivait QUE dans GA4 : impossible de savoir, commande
     par commande depuis l'admin, si le client avait pris quelque chose sur l'Étal.
     On le réinscrit donc dans l'attribut, dès le premier ajout :
       "A-plaisir"                → l'Étal a été montré, rien pris
       "A-plaisir-2ajouts-8.70"   → 2 ajouts, 8,70 € ajoutés au panier
     Sans ajout, aucun appel réseau supplémentaire (le cas de loin le plus fréquent). */
  function markOrderWithAdds() {
    if (!state.mode || state.addsCount <= 0) return;
    const n = state.addsCount;
    markOrder(
      state.bucket + '-' + state.mode +
      '-' + n + (n > 1 ? 'ajouts' : 'ajout') +
      '-' + (state.addsValueCents / 100).toFixed(2)
    );
  }

  /* ===== Détermination du mode ===== */

  /* Largeur de la fenêtre « presque-seuil », en centimes.
     Source unique : le réglage Customizer, posé par sections/ei-cart-popover.liquid
     sur data-ei-smart-fenetre. Repli sur CONFIG si l'attribut manque (ancien thème,
     ou section du tiroir absente de la page). */
  function interceptWindowCents() {
    const overlay = $('[data-ei-cart-popover]');
    const v = overlay && parseInt(overlay.dataset.eiSmartFenetre, 10);
    return (v && v > 0) ? v : CONFIG.INTERCEPT_WINDOW_CENTS;
  }

  function resolveMode(seuilBaseCents) {
    const overlay = $('[data-ei-cart-popover]');
    const isCampagneLive = overlay && overlay.dataset.eiCampagneLive === 'true';
    const fenetre = interceptWindowCents();

    if (isCampagneLive) {
      const seuilCampagne = parseInt(overlay.dataset.eiCampagneSeuil || '30', 10) * 100;
      if (seuilBaseCents >= seuilCampagne - fenetre && seuilBaseCents < seuilCampagne) {
        state.activeSeuil = seuilCampagne;
        state.deltaCents = seuilCampagne - seuilBaseCents;
        return 'seuil';
      }
      return 'plaisir';
    }

    if (seuilBaseCents >= CONFIG.SEUIL_RELAIS - fenetre && seuilBaseCents < CONFIG.SEUIL_RELAIS) {
      state.activeSeuil = CONFIG.SEUIL_RELAIS;
      state.deltaCents = CONFIG.SEUIL_RELAIS - seuilBaseCents;
      return 'seuil';
    }
    /* Le palier DOMICILE (90 €) garde volontairement sa fenêtre de 5 € : élargissement
       non demandé par Margot, à arbitrer séparément. Voir le même choix dans
       ei-cart-popover.js. */
    if (seuilBaseCents >= CONFIG.SEUIL_DOMICILE - 500 && seuilBaseCents < CONFIG.SEUIL_DOMICILE) {
      state.activeSeuil = CONFIG.SEUIL_DOMICILE;
      state.deltaCents = CONFIG.SEUIL_DOMICILE - seuilBaseCents;
      return 'seuil';
    }
    return 'plaisir';
  }

  /* ===== Sélection des produits affichés ===== */
  function selectItems(mode) {
    const pool = readPool();
    const s = state.settings;
    const cart = state.cartRef || getCart();
    const inCart = cart && Array.isArray(cart.items)
      ? cart.items.map(i => i.handle)
      : [];

    const candidates = pool.filter(p => inCart.indexOf(p.h) === -1);
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const nb = isMobile ? s.nbMobile : s.nbDesktop;

    if (mode === 'seuil') {
      /* On ne montre QUE des produits qui débloquent réellement le palier :
         prix >= delta. Sinon on promettrait une livraison offerte que l'ajout
         ne déclenche pas. Tri du moins cher au plus cher = le plus proche du
         delta en premier (ici seulement, l'ordre manuel de la collection cède
         la place au critère fonctionnel). */
      const eligibles = candidates
        .filter(p => p.p >= state.deltaCents)
        .sort((a, b) => a.p - b.p);
      /* null = pas assez de choix : l'appelant bascule en version "petits plaisirs" */
      return eligibles.length >= CONFIG.MIN_ITEMS ? eligibles.slice(0, nb) : null;
    }

    /* Version "petits plaisirs" : on respecte l'ordre manuel de la collection */
    return candidates.slice(0, nb);
  }

  /* ===== Rendu ===== */
  function textsFor(mode) {
    const el = modalRoot();
    const d = el ? el.dataset : {};
    const deltaEur = moneyFormat(state.deltaCents);

    if (mode === 'seuil') {
      const isDomicile = state.activeSeuil === CONFIG.SEUIL_DOMICILE;
      return {
        eyebrow: (d.eiEtalEyebrowSeuil || 'Plus que [montant]…').replace('[montant]', deltaEur),
        title: (d.eiEtalTitreSeuil || '…et la <strong>livraison est offerte</strong>').replace('[montant]', deltaEur),
        sub: (d.eiEtalSoustitreSeuil || 'Margot a sorti quelques petits formats qui tombent pile.')
          .replace('[montant]', deltaEur)
          .replace('{mode}', isDomicile ? 'à domicile' : 'en point relais')
      };
    }
    return {
      eyebrow: d.eiEtalEyebrowPlaisir || "Un dernier tour de l'étal ?",
      title: d.eiEtalTitrePlaisir || "Les <strong>petits plaisirs</strong> qu'on oublie toujours",
      sub: d.eiEtalSoustitrePlaisir || "Un clic, c'est dans le colis."
    };
  }

  function renderModal() {
    const root = modalRoot();
    if (!root) return;
    const t = textsFor(state.mode);

    const eyebrowEl = $('[data-ei-st-eyebrow]', root);
    const titleEl = $('[data-ei-st-title]', root);
    const subEl = $('[data-ei-st-subtitle]', root);
    if (eyebrowEl) eyebrowEl.textContent = t.eyebrow;
    if (titleEl) titleEl.innerHTML = t.title;
    if (subEl) subEl.innerHTML = t.sub;

    root.dataset.eiEtalMode = state.mode;

    /* Jauge : mode seuil uniquement */
    const gauge = $('[data-ei-st-gauge]', root);
    if (gauge) {
      if (state.mode === 'seuil') {
        gauge.removeAttribute('hidden');
        updateGauge();
      } else {
        gauge.setAttribute('hidden', '');
      }
    }

    /* Cartes produits */
    const grid = $('[data-ei-st-suggestions]', root);
    if (grid) {
      grid.innerHTML = state.items.map((it, i) => `
        <div class="ei-st-card" data-ei-st-card data-ei-st-idx="${i}" role="listitem">
          <div class="ei-st-card-img">
            ${it.i
              ? `<img src="${it.i}" alt="" width="110" height="110" loading="lazy" decoding="async">`
              : '<span aria-hidden="true">🫒</span>'}
          </div>
          <p class="ei-st-card-name">${escapeHtml(it.t)}</p>
          <div class="ei-st-card-bottom">
            <span class="ei-st-card-price">${moneyFormat(it.p)}</span>
            <button
              type="button"
              class="ei-st-card-add"
              data-ei-st-action="add"
              data-ei-st-idx="${i}"
              data-ei-variant-id="${it.v}"
              data-ei-product-handle="${it.h}"
              aria-label="Ajouter ${escapeHtml(it.t)} au panier"
            >+</button>
          </div>
        </div>`).join('');
    }

    updateCtaAmount();
  }

  function updateCtaAmount() {
    const el = $('[data-ei-st-cta-amount]');
    if (el) el.textContent = moneyFormat(state.totalCents);
  }

  function updateGauge() {
    const root = modalRoot();
    if (!root || state.mode !== 'seuil' || !state.activeSeuil) return;
    const fill = $('[data-ei-st-gauge-fill]', root);
    const txt = $('[data-ei-st-gauge-txt]', root);
    /* Base = total AVANT promo (stratégie A code promo, cohérente avec le calcul du delta) */
    const pct = Math.min(100, (state.seuilBaseCents / state.activeSeuil) * 100);
    if (fill) fill.style.width = pct + '%';
    if (txt) {
      if (state.seuilBaseCents >= state.activeSeuil) {
        txt.innerHTML = '🎉 <strong>Livraison offerte débloquée</strong>';
        txt.classList.add('is-reached');
      } else {
        const reste = state.activeSeuil - state.seuilBaseCents;
        const label = state.activeSeuil === CONFIG.SEUIL_DOMICILE ? 'à domicile' : 'en point relais';
        txt.innerHTML = 'Encore <strong>' + moneyFormat(reste) + '</strong> pour la livraison offerte ' + label;
        txt.classList.remove('is-reached');
      }
    }
  }

  function toast(message) {
    const el = $('[data-ei-st-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-on');
    clearTimeout(el._eiTimer);
    el._eiTimer = setTimeout(() => el.classList.remove('is-on'), 1800);
  }

  /* ===== Ouverture / fermeture ===== */
  function openModal() {
    const root = modalRoot();
    if (!root || state.isOpen) return;
    root.removeAttribute('hidden');
    root.classList.remove('is-closing');
    document.body.classList.add('ei-st-body-locked');
    state.isOpen = true;
    setTimeout(() => {
      const inner = $('[data-ei-st-modal]', root);
      if (inner) inner.focus({ preventScroll: true });
    }, 100);

    pushGA4('ei_etal_shown', {
      ei_etal_nb: state.items.length,
      ei_threshold_seuil: state.activeSeuil ? state.activeSeuil / 100 : null
    });
    try { localStorage.setItem('ei_etal_last_shown_at', new Date().toISOString()); } catch (e) {}
  }

  function closeModal(after) {
    const root = modalRoot();
    if (!root || !state.isOpen) { if (typeof after === 'function') after(); return; }
    root.classList.add('is-closing');
    setTimeout(() => {
      root.setAttribute('hidden', '');
      root.classList.remove('is-closing');
      document.body.classList.remove('ei-st-body-locked');
      state.isOpen = false;
      if (typeof after === 'function') after();
    }, 260);
  }

  function markSeen() {
    try { sessionStorage.setItem(CONFIG.SEEN_KEY, '1'); } catch (e) {}
  }

  /* ===== Ajout d'un produit ===== */
  async function handleAdd(btn) {
    const idx = parseInt(btn.dataset.eiStIdx, 10);
    const item = state.items[idx];
    const variantId = btn.dataset.eiVariantId;
    if (!item || !variantId || btn.disabled) return;

    btn.disabled = true;
    const card = btn.closest('[data-ei-st-card]');

    /* Retour immédiat (optimiste) : c'est le ressort du kiosque */
    state.totalCents += item.p;
    state.seuilBaseCents += item.p;
    state.addsCount += 1;
    state.addsValueCents += item.p;
    updateCtaAmount();
    updateGauge();
    if (card) card.classList.add('is-added');
    btn.textContent = '✓';
    const cta = $('[data-ei-st-cta]');
    if (cta) {
      cta.classList.remove('is-bump');
      void cta.offsetWidth;
      cta.classList.add('is-bump');
    }
    toast('✓ ' + item.t + ' ajouté');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('add failed ' + res.status);

      /* Réconciliation sur le VRAI panier Shopify, pas sur le cache du popover :
         refresh() ne remet pas à jour sa variable interne, ce qui faisait
         retomber le montant du CTA à sa valeur d'avant l'ajout. */
      try {
        const fresh = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
        if (fresh && typeof fresh.total_price === 'number') {
          state.cartRef = fresh;
          state.totalCents = fresh.total_price;
          state.seuilBaseCents = fresh.total_price; /* 2026-10-02 : après remise */
          updateCtaAmount();
          updateGauge();
        }
      } catch (eFresh) { /* on garde l'affichage optimiste */ }

      /* Le popover se remet à jour de son côté (badge, lignes, barre de progression) */
      if (window.eiCartPopover) { window.eiCartPopover.refresh(); }

      /* Après la réconciliation seulement : l'ajout est confirmé côté serveur.
         Réécrit à chaque ajout, donc juste même si le client ferme le calque
         au lieu de cliquer "Commander". */
      markOrderWithAdds();

      pushGA4('ei_etal_add', {
        ei_product: item.h,
        ei_price: item.p / 100,
        ei_etal_nb_ajouts: state.addsCount,
        new_cart_total: state.totalCents / 100
      });
    } catch (err) {
      /* Rollback visuel si l'ajout a échoué */
      state.totalCents -= item.p;
      state.seuilBaseCents -= item.p;
      state.addsCount -= 1;
      state.addsValueCents -= item.p;
      updateCtaAmount();
      updateGauge();
      if (card) card.classList.remove('is-added');
      btn.textContent = '+';
      btn.disabled = false;
      toast('Ajout impossible, réessayez');
      console.error('[ei-etal] add failed', err);
    }
  }

  /* ===== Sorties ===== */
  function handleProceed() {
    markSeen();
    /* Filet : si un marquage a été perdu en route, on réécrit le total juste
       avant de partir au paiement (keepalive → survit à la navigation). */
    markOrderWithAdds();
    pushGA4('ei_etal_proceed', {
      ei_etal_nb_ajouts: state.addsCount,
      ei_etal_valeur_ajoutee: state.addsValueCents / 100
    });
    closeModal(() => {
      window.location.href = state.pendingCheckoutHref || '/checkout';
    });
  }

  function handleBack() {
    markSeen();
    pushGA4('ei_etal_back', {
      ei_etal_nb_ajouts: state.addsCount,
      ei_etal_valeur_ajoutee: state.addsValueCents / 100
    });
    closeModal();
  }

  /* ===== Listener principal ===== */
  function handleCheckoutClicked(e) {
    /* Priorité au rappel "petit mot" Mamma : s'il a déjà bloqué, on s'efface */
    if (e.defaultPrevented) return;

    const root = modalRoot();
    if (!root) return; /* Étal désactivé côté Customizer : rien n'est rendu */

    state.settings = readSettings();
    if (!state.settings) return;

    try { if (sessionStorage.getItem(CONFIG.SEEN_KEY) === '1') return; } catch (err) {}

    /* Panier de référence : celui porté par l'événement en priorité, sinon
       celui du popover. Si les deux sont vides/périmés, on n'intercepte PAS —
       mieux vaut laisser filer vers le paiement que d'afficher un
       « Commander · 0,00 € » ou de choisir la mauvaise version. */
    const detail = e.detail || {};
    const cartFromEvent = detail.cart && detail.cart.item_count ? detail.cart : null;
    const cart = cartFromEvent || getCart();
    if (!cart || !cart.item_count) return;

    const totalCents = cart.total_price || 0;
    /* 2026-10-02 : le seuil se juge sur le total APRÈS remise, comme le tunnel Shopify */
    const seuilBase = detail.seuilBaseCents || totalCents;
    if (totalCents <= 0 || seuilBase <= 0) return;

    state.cartRef = cart;

    /* Panier minimum */
    if (totalCents < state.settings.panierMinCents) return;

    let mode = resolveMode(seuilBase);
    state.bucket = getBucket(state.settings.holdout);

    /* Groupe témoin : on marque la commande, on signale à GA4 que ce visiteur
       fait partie du témoin (sinon il n'existerait nulle part et la comparaison
       exposés / témoins serait impossible), et on laisse filer vers le paiement. */
    if (state.bucket === 'B') {
      state.mode = mode;
      markOrder('B-' + mode);
      pushGA4('ei_etal_holdout', { ei_etal_nb: 0 });
      return;
    }

    let items = selectItems(mode);

    /* Pas assez de produits qui débloquent vraiment le palier ?
       On ne ment pas : on repasse en version "petits plaisirs", sans jauge. */
    if (mode === 'seuil' && !items) {
      mode = 'plaisir';
      state.activeSeuil = null;
      state.deltaCents = 0;
      items = selectItems(mode);
    }

    if (!items || items.length < CONFIG.MIN_ITEMS) return; /* on ne bloque jamais pour rien */

    /* À partir d'ici seulement on intercepte */
    e.preventDefault();

    const btn = document.activeElement && document.activeElement.closest
      ? document.activeElement.closest('[data-ei-checkout-button]')
      : null;
    state.pendingCheckoutHref = (btn && btn.tagName === 'A' && btn.href) ? btn.href : '/checkout';

    state.mode = mode;
    state.items = items;
    state.totalCents = totalCents;
    state.seuilBaseCents = seuilBase || totalCents;
    state.addsCount = 0;
    state.addsValueCents = 0;

    markOrder('A-' + mode);
    renderModal();
    openModal();
  }

  /* ===== Délégation d'événements ===== */
  function setupEventDelegation() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-ei-st-action]');
      if (!btn) return;
      const action = btn.dataset.eiStAction;
      if (action === 'add') {
        handleAdd(btn);
      } else if (action === 'proceed') {
        e.preventDefault();
        handleProceed();
      } else if (action === 'back' || action === 'dismiss') {
        e.preventDefault();
        handleBack();
      }
    });

    /* Clic sur le fond = retour panier */
    document.addEventListener('click', (e) => {
      const root = modalRoot();
      if (!root || root.hasAttribute('hidden')) return;
      if (e.target === root) handleBack();
    });

    document.addEventListener('keydown', (e) => {
      if (!state.isOpen) return;
      if (e.key === 'Escape') handleBack();
      if (e.key === 'Tab') trapFocus(e);
    });
  }

  function trapFocus(e) {
    const root = modalRoot();
    if (!root || root.hasAttribute('hidden')) return;
    const inner = $('[data-ei-st-modal]', root);
    if (!inner) return;
    const focusables = $$('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])', inner);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  /* ===== Init ===== */
  function init() {
    document.addEventListener('ei:checkout-clicked', handleCheckoutClicked);
    setupEventDelegation();

    window.eiEtal = {
      open: openModal,
      close: closeModal,
      isOpen: () => state.isOpen,
      getState: () => state,
      pool: readPool,
      reset: () => {
        try {
          sessionStorage.removeItem(CONFIG.SEEN_KEY);
          localStorage.removeItem(CONFIG.BUCKET_KEY);
        } catch (e) {}
      }
    };
    /* Compat : ancien nom conservé pour ne pas casser un éventuel appel externe */
    window.eiSmartThreshold = window.eiEtal;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
